'use client'

import styled from 'styled-components'

import {
  NextDialog,
  NextDialogBackdrop,
  NextDialogDismiss,
  NextDialogDrawerProps,
} from './NextDialog.client'

export const NextDrawerDialogFooter = styled.footer`
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  padding: ${o => o.theme.dimensions.layout.sidePadding.md}px;
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
`

const NextDrawerDialogDismiss = styled(NextDialogDismiss)`
  position: fixed;
  top: ${o => o.theme.dimensions.layout.sidePadding.md}px;
  right: ${o => o.theme.dimensions.layout.sidePadding.md}px;
  z-index: 1;
`

type NextDrawerDialogProps = NextDialogDrawerProps & {
  closeText: string
}

export const NextDrawerDialog = styled(
  ({
    children,
    variant,
    closeText,
    backdrop = NextDialogBackdrop,
    ...props
  }: NextDrawerDialogProps) => (
    <NextDialog backdrop={backdrop} variant={variant} {...props}>
      <NextDrawerDialogDismiss $pinTo={'top-right'} aria-label={closeText} />
      {children}
    </NextDialog>
  )
)``
